<template>
  <div>
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { userLoadApi } from "@/config/appSettings";
export default {
  name: "Dashboard",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    auth: null
  }),

  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: { ...mapGetters(["profileStore"]) },
  methods: {
    async setProfileType() {
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }

      //console.log("PROFILE STORE DASHBOARD:", this.profileStore);
      if (this.profileStore !== false) {
        try {
          if (this.profileStore.profileTypes.length > 0) {
            if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
              this.isInfluencer = true;
            }
            if (this.profileStore.profileTypes.indexOf("client") !== -1) {
              this.isClient = true;
            }
          }
        } catch (err) {
          //console.log("ERROR:", err);
        }
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE

      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
    async loadPageContent() {
      //console.log("LOADING PROFILE:", this.profileStore);
      await this.setProfileType();

      if (this.isClient == true) {
        if (this.profileStore.relatedClients.length > 0) {
          this.$router.push(
            `/account/active-shopify/${this.profileStore.relatedClients[0].clientId}`
          );
        }
      }
    }
  },
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  }
};
</script>

<style scoped>
</style>